export function mySavedSearchesPath() {
  return '/me/saved-searches'
}
